import React from "react";
import { Fade, Zoom } from "react-reveal";
// import logo
import Logo from "../assets/img/favicon.png";
// import social data
import { social } from "../data";

const Footer = () => {
  return (
    <footer className="bg-tertiary py-12">
      <div className="container mx-auto">
        <div className="flex flex-col lg:flex-row space-y-6 lg:space-y-0 items-center justify-between">
          <div className="flex space-x-6 items-center justify-center">
            {social.map((item, index) => {
              const { href, icon } = item;
              return (
                <Fade left>
                  <a
                    target={`_blank`}
                    className="text-accent text-2xl"
                    href={href}
                    key={index}
                  >
                    {icon}
                  </a>
                </Fade>
              );
            })}
          </div>
          <div>
            <Zoom>
              <a className="flex items-center gap-1" href="#!">
                <img className="w-16" src={Logo} alt="" />{" "}
                <span className="text-3xl font-bold">Developer Ashraful</span>
              </a>
            </Zoom>
          </div>
          <Fade right>
            <p className="text-paragraph opacity-80 text-[15px]">
              &copy; {new Date().getFullYear()} Developer Ashraful. All rights
              reserved.
            </p>
          </Fade>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
